<template>
  <div class="brauty">
    <!--头部搜索-->
    <div style="margin-bottom: 10px;">
      <el-autocomplete id="disableInput" v-model.trim="phoneSearchVal" style="width: 260px;" :fetch-suggestions="querySearchAsync" placeholder="请输入手机号/名称/会员卡号" class="keywordSearch" popper-class="customerPopper" :clearable="true" @select="newCheckMember">
        <i slot="suffix" class="el-icon-search phone_book" @click="phoneSearch"></i>
        <template slot-scope="{ item }">
          <div class="customerList">
            <p>
              <span>{{ item.customerName || '新增顾客' }}</span>
              <samp>{{ Lib.starPhone(item.value) }}</samp>
            </p>
            <h1>{{ item.cardNo ? ('会员卡号：'+item.cardNo) : '非会员' }}</h1>
          </div>
        </template>
      </el-autocomplete>
      <i class="iconfont phone_book new_phone_style" @click="onCheckPhoneBook">&#xe646;</i>
      <div :class="starPhoneVal ? 'starPhoneClass' : ''">{{ starPhoneVal }}</div>
    </div>
    <gt-customerInfo v-if="MemberInfo.cardNo || (!MemberInfo.cardNo && searchBeforePhone)" :member-info="MemberInfo" :search-val="phoneSearchVal" :refresh-data="refreshData"></gt-customerInfo>
    <!-- tabs -->
    <i v-if="tabsType == 'first'" class="iconfont screen" @click="display = true">&#xe63f;</i>
    <el-tabs v-model="tabsType" type="card" @tab-click="tabClick">
      <el-tab-pane label="套餐办理" name="first">
        <drawer title="套餐筛选" :display.sync="display">
          <div class="li">
            <p>套餐类型</p>
            <el-button size="small" round :plain="limitType == '' ? false : true" type="primary" @click="changeMeal('')">全部套餐</el-button>
            <el-button size="small" round :plain="limitType == 1 ? false : true" type="primary" @click="changeMeal(1)">有限次数套餐</el-button>
            <el-button size="small" round :plain="limitType == 2 ? false : true" type="primary" @click="changeMeal(2)">无限次数套餐</el-button>
            <el-button size="small" round :plain="limitType == 3 ? false : true" type="primary" @click="changeMeal(3)">通用次数套餐</el-button>
            <el-button size="small" round :plain="limitType == 4 ? false : true" type="primary" @click="changeMeal(4)">活动套餐</el-button>
            <el-button size="small" round :plain="limitType == 5 ? false : true" type="primary" @click="changeMeal(5)">特价促销套餐</el-button>
            <el-button size="small" round :plain="limitType == 6 ? false : true" type="primary" @click="changeMeal(6)">定时打折套餐</el-button>
            <el-button size="small" round :plain="limitType == 7 ? false : true" type="primary" @click="changeMeal(7)">买赠活动套餐</el-button>
            <el-button size="small" round :plain="limitType == 8 ? false : true" type="primary" @click="changeMeal(8)">满赠活动套餐</el-button>
          </div>
          <!-- <div class="dfoot" @click="resetScreen">重置</div> -->
        </drawer>
        <div v-if="!MemberInfo.cardNo && !searchBeforePhone" class="beautyTop">
          <div class="tipInfo"><i class="el-icon-warning"></i>温馨提示，请先输入顾客的信息后，再发起套餐办理或划扣</div>
        </div>
        <!--套餐列表（noneData无列表情况）-->
        <div v-loading="Cmloading">
          <div v-if="cardList.length > 0" class="beauty_content calc_T">
            <ul class="calc_ul" @scroll="scrollData">
              <li v-for="(item,index) in cardList" :key="index">
                <div class="liLeft">
                  <div class="img">
                    <gt-coverImg :img-class="'liOne_img'" :img-url="item.vipCardImgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
                  </div>
                </div>
                <div class="liRight">
                  <h1>{{ item.vipCardName }}</h1>
                  <h2 style="padding: 15px 0;">
                    <label>{{ item.validType == 1 ? '有效时间：' : item.validType == 2 ? '使用期限：' : '有效天数：' }}</label>
                    {{ item.validType == 1 ? item.type==2?(item.startTime+'至'+item.pastTime):(item.startTime+'至'+ item.endTime) : item.validType == 2 ? '永久有效' : ((item.validTime ? item.validTime : '0')+'天') }}
                    <span>￥{{ item.price }}</span>
                  </h2>
                  <h2>
                    <label>套餐类型：{{ item.countLimitType == 1 ? '有限次数' : item.countLimitType == 2 ? '无限次数' : '通用次数' }}</label>
                    <del>￥{{ item.itemsPrice }}</del>
                  </h2>
                  <h3>
                    <el-tag v-if="item.activityInfo" style="border: 0;" :color="Lib.getActivity(item.activityInfo.activityType,4)" effect="dark">{{ Lib.getActivity(item.activityInfo.activityType,2) }}</el-tag>
                    <samp @click="lookPackageInfo(item)">详情<i class="el-icon-arrow-right"></i></samp>
                  </h3>
                </div>
              </li>
            </ul>
          </div>
          <gt-noneData v-if="cardList.length == 0" :title="'暂无可购买的套餐'"></gt-noneData>
        </div>
      </el-tab-pane>
      <el-tab-pane label="划扣" name="second">
        <!--套餐列表（noneData无列表情况）-->
        <div v-loading="Cmloading">
          <div v-if="deductList.length > 0" class="beauty_content calc_T">
            <ul class="calc_ul">
              <li v-for="(item,index) in deductList" :key="index">
                <div class="liLeft">
                  <div class="img">
                    <gt-coverImg :img-class="'liOne_img'" :img-url="item.imgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
                  </div>
                </div>
                <div class="liRight">
                  <h4>{{ item.name }}<del>￥{{ (item.itemsPrice*1+item.productsPrice*1).toFixed(2) }}</del></h4>
                  <h5>
                    <label>到期时间：</label>{{ item.expireTime }}
                    <span>￥{{ item.price }}</span>
                  </h5>
                  <h3>
                    <samp @click="openListy(item.vipCardId || item.eitemId,item.clientVipCardId)">详情<i class="el-icon-arrow-right"></i></samp>
                  </h3>
                </div>
                <div class="liTop" :class="item.type == 2 ? 'liCone' : item.type == 3 ? 'liCtwo' : 'liCthree'">{{ item.type == 2 ? (item.countLimitType == 2 ? '已拥有，无限次数' : ('已拥有，剩余'+item.remaining+'次')) : item.type == 3 ? '已用完' : '已过期' }}</div>
              </li>
            </ul>
          </div>
          <gt-noneData v-if="deductList.length == 0" :title="MemberInfo.cardNo || (!MemberInfo.cardNo && searchBeforePhone) ? '暂无可划扣的套餐' : '请输入顾客信息'"></gt-noneData>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!--弹框-member注册会员/顾客详情/套餐详情-->
    <gt-memberDig @memberUrl="memberUrl"></gt-memberDig>

    <!--顾客列表-->
    <book :show.sync="innerVisible" />

    <!-- 套餐信息 -->
    <el-dialog title="套餐信息" :visible.sync="packageInfoDia" :append-to-body="true" width="960px">
      <div class="infoTop">
        <div class="itLeft">
          <gt-coverImg :img-class="'liOne_img'" :img-url="lookInfo.vipCardImgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
        </div>
        <div class="itRight">
          <p>套餐名称：{{ lookInfo.vipCardName }}</p>
          <p>
            套餐类型：{{ lookInfo.countLimitType == 1 ? '有限次数' : lookInfo.countLimitType == 2 ? '无限次数' : '通用次数' }}<label>{{ lookInfo.countLimitType == 3 ? ('（'+lookInfo.universalCount+'次）') : '' }}</label>
          </p>
        </div>
        <div class="itRight">
          <p>套餐金额：<del>￥{{ lookInfo.itemsPrice }}</del><span>￥{{ lookInfo.price }}</span></p>
          <p>可用门店：共{{ lookInfo.useStoreList.length }}个门店<el-popover placement="right" trigger="click"><div v-for="(v,n) in lookInfo.useStoreList" :key="n" style="padding: 3px 12px;">{{ v.name }}</div><samp slot="reference">查看全部</samp></el-popover></p>
        </div>
        <div class="itRight">
          <p>
            {{ lookInfo.validType == 1 ? '有效时间：' : lookInfo.validType == 2 ? '使用期限：' : '有效天数：' }}
            {{ lookInfo.validType == 1 ? lookInfo.type==2?(lookInfo.startTime+'至'+lookInfo.pastTime):(lookInfo.startTime+'至'+ lookInfo.endTime) : lookInfo.validType == 2 ? '永久有效' : ((lookInfo.validTime ? lookInfo.validTime : '0')+'天') }}
          </p>
          <p>套餐限购：{{ lookInfo.limitPurchase ? ('限购'+lookInfo.limitPurchase+'次') : '不限购' }}</p>
        </div>
      </div>
      <div v-if="lookInfo.activityInfo" class="infoMiddle">
        <el-tag class="mLeft" style="border: 0;" :color="Lib.getActivity(lookInfo.activityInfo.activityType,4)" effect="dark">{{ Lib.getActivity(lookInfo.activityInfo.activityType,2) }}</el-tag>
        <div class="mRight">
          <div class="mrTop">
            <p><span>活动名称：</span><samp>{{ lookInfo.activityInfo.activityName }}</samp></p>
            <p><span>参与人员：</span><samp>{{ lookInfo.activityInfo.participationType == 1 ? '全部通用' : '会员参与' }}</samp></p>
            <p><span>活动时间：</span><samp>{{ lookInfo.activityInfo.startTime }}至{{ lookInfo.activityInfo.endDate }}</samp></p>
          </div>
          <div class="mrBottom">
            <span class="mrbLeft">活动内容：</span>
            <div class="mrbRight">
              <h5 v-if="lookInfo.activityInfo.activityType == 1">特价促销<samp class="themeFC">￥{{ lookInfo.activityInfo.activityPrice }}</samp><label v-if="lookInfo.activityInfo.promotionSaleCount*1 > 9999">，不限购</label><label v-else>，限购<samp class="themeFC">{{ lookInfo.activityInfo.promotionSaleCount }}</samp>件</label></h5>
              <h5 v-else-if="lookInfo.activityInfo.activityType == 2"><span>活动周期：</span><samp>{{ getCycle(lookInfo.activityInfo.activityDays,lookInfo.activityInfo.cycleType) }}</samp></h5>
              <h6 v-if="lookInfo.activityInfo.activityType == 2">
                <span>优惠时间：</span>
                <samp v-for="(a,b) in lookInfo.activityInfo.lookActivityDiscountTimeList" :key="b">{{ a.startTime }}~{{ a.endTime }}，打<b class="themeFC">{{ a.discount }}</b>折； </samp>
              </h6>
              <div v-else-if="lookInfo.activityInfo.activityType == 3">
                <h5 v-for="(c,d) in lookInfo.activityInfo.lookActivityGivenList" :key="d">{{ c.givenType == 1 ? '买满' : '每买满' }}<span class="themeFC">{{ c.buyNumber }}</span>件送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
              </div>
              <div v-else-if="lookInfo.activityInfo.activityType == 4">
                <h5 v-for="(c,d) in lookInfo.activityInfo.lookActivityGivenList" :key="d">购买指定商品满<span class="themeFC">{{ c.satisfyPrice }}</span>元送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-table v-if="lookInfo.vipCardItemInfoDto ? lookInfo.vipCardItemInfoDto.length > 0 ? true : false : false" :style="lookInfo.basePackageProductList ? lookInfo.basePackageProductList.length > 0 ? 'margin-bottom: 20px;' : '' : ''" :data="lookInfo.vipCardItemInfoDto">
        <el-table-column prop="dictItemName" label="项目名称"></el-table-column>
        <el-table-column prop="dictTypeName" label="所属分类"></el-table-column>
        <el-table-column label="次数">
          <template slot-scope="scope">
            <span>{{ lookInfo.countLimitType == 1 ? scope.row.count : lookInfo.countLimitType == 2 ? '无限次数' : '通用次数' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="lookInfo.basePackageProductList ? lookInfo.basePackageProductList.length > 0 ? true : false : false" :data="lookInfo.basePackageProductList">
        <el-table-column prop="productName" label="产品名称"></el-table-column>
        <el-table-column prop="specification" label="规格"></el-table-column>
        <el-table-column label="次数">
          <template slot-scope="scope">
            <span>{{ lookInfo.countLimitType == 1 ? scope.row.productCount : lookInfo.countLimitType == 2 ? '无限次数' : '通用次数' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button v-if="MemberInfo.cardNo || (!MemberInfo.cardNo && searchBeforePhone)" type="primary" @click="recharge(lookInfo)">{{ lookInfo.type == 1 ? '购买' : '续费' }}</el-button>
          <p v-else style="padding-bottom: 12px;">温馨提示：若要购买，请先输入客户信息</p>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="套餐详情" :visible.sync="cardListShow" width="1000px" class="beauty_setmeal_details">
      <ScribingDetails :show="cardListShow" :details-data="detailsData" :details-loading="detailsLoading" :search-before-phone="searchBeforePhone" :member-info="MemberInfo" :open-listy="openListy" :phone-search="phoneSearch" :get-deduct-list="getDeductList" :edit-card-list-show="editCardListShow" :recharge="recharge"></ScribingDetails>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBeautyPackageList, // 会员套餐列表
  getMemberCardMsg,
  getCustomerMsgList, // 顾客详情列表
  getDeductList, // （6.7）获取会员可划扣列表(含套餐+电子票)
  getDeductDetails, // (6.7)获取会员可划扣详情
  getPayCodeList, // (3.8.0)获得店铺结算设置信息
} from '../api';
import book from './book';
import drawer from '../../../../publicVue/drawer';
// 6.81
import ScribingDetails from './dialog/scribingDetails.vue';

export default {
  components: {
    book,
    ScribingDetails,
    drawer
  },
  data() {
    return {
      Cmloading: false, // 筛选加载
      detailsData: {
        vipCardBuyOrderList: []
      }, // 详情内容
      limitType: '', // 套餐类型
      cardListShow: false, // 弹出
      loading: false, // 滚动加载
      projectData: [],
      form: {
        memberDialog: false,
        phone: ''
      },
      phoneSearchStatus: false,
      phoneSearchVal: '', // 查询顾客的值
      MemberInfo: {
        headImgUrl: '', // 会员头像地址
        nickName: '', // 会员手机号码
        receiveDate: '', // 创建时间
        fansCurrency: '', // 粉币数量
        money: '', // 余额
        cardNo: '', // 会员卡号
        integral: '', // 积分
        phone: '' // 会员手机
      },
      cardList: [],
      pageNum: 1,
      rowCount: 1,
      pageSize: 10, // 每页数据量

      uaValue: '', // 判断是手机端还是PC端   pc为PC端，mobile为手机端
      tooltipStatus: false, // 气泡显示

      innerVisible: false,

      editStatus: 1, // 编辑用户姓名状态   1未编辑  2编辑中
      searchBeforePhone: '', // 搜索之后的非会员的手机号

      openListKey: [], // 打开列表的key值
      rechargeStatus: 1, // 首次进入的状态

      starPhoneVal: '',
      starStatus: 1,
      // 6.7
      tabsType: 'first',
      deductList: [],
      detailsLoading: true,
      // 6.81
      display: false,
      packageInfoDia: false,
      lookInfo: {
        useStoreList: []
      },
    };
  },
  watch: {
    phoneSearchVal(val) {
      if (this.starStatus == 2 && window.sessionStorage.isHidePhone == 1) {
        this.starPhoneVal = val.length == 4 ? '*' : val.length == 5 ? '**' : val.length == 6 ? '***' : val.length > 6 ? '****' : '';
      } else {
        this.starPhoneVal = '';
      }
      if (val.length < 4) {
        this.starStatus = 1;
      }
      if (val.length < 10 > 1) return;
      this.pageNum = 1;
      val.length == 11 || !val ? (this.tabsType == 'first' ? this.phoneSearch() : this.getDeductList()) : (this.phoneSearchStatus = false);
    },
  },
  activated() {
    this.pageNum = 1;
    this.uaValue = this.Lib.pcOrMobile();
    this.openListKey = [];
    this.phoneSearchVal = window.sessionStorage.rechargePhone ? window.sessionStorage.rechargePhone : '';
    this.rechargeStatus = 1;
    if (this.tabsType == 'first') {
      this.phoneSearch();
    } else {
      this.getDeductList();
    }
    this.getPayList();
    const disable = document.getElementById('disableInput');
    disable.addEventListener('mousedown', (e) => {
      e.preventDefault();
    });
    disable.addEventListener('click', () => {
      disable.focus();
    });
  },
  methods: {
    refreshData() {
      this.phoneSearch();
    },
    // 6.81
    resetScreen() {
      this.limitType = '';
    },
    lookPackageInfo(obj) {
      this.packageInfoDia = true;
      this.lookInfo = obj;
    },
    // 获取支付方式列表
    getPayList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getPayCodeList(data).then((res) => {
        if (res.code == 0 && res.data) {
          this.payCodeList = res.data;
          res.data.forEach((a) => {
            if (a.payType == 40) {
              window.sessionStorage.isAutograph = a.isOpen == 0 ? 1 : 2;
            }
          });
        }
      });
    },
    tabClick(tab) {
      if (tab.name == 'first') {
        this.phoneSearch();
      } else {
        this.getDeductList();
      }
    },
    getDeductList() {
      const data = {
        mainId: window.sessionStorage.mainId,
        phone: this.phoneSearchVal
      };
      if (this.phoneSearchVal) {
        this.checkMember();
      }
      this.searchBeforePhone = this.phoneSearchVal;
      getDeductList(data).then((res) => {
        if (res.code == 0) {
          this.deductList = res.data;
        } else {
          console.log(res.data);
        }
      });
    },
    // 获取周期展示
    getCycle(val, status) {
      const arr = val.split(',');
      const newArr = arr.sort();
      const lastArr = [];
      newArr.forEach((v) => {
        if (v) lastArr.push(v);
      });
      let cycleArr = '';
      if (status == 1) {
        newArr.forEach((a, m) => {
          if (a == 1) cycleArr += `周一${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 2) cycleArr += `周二${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 3) cycleArr += `周三${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 4) cycleArr += `周四${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 5) cycleArr += `周五${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 6) cycleArr += `周六${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 7) cycleArr += `周日${newArr.length == (m + 1) ? '' : '、'}`;
        });
      } else {
        newArr.forEach((b, n) => {
          if (n == 0) cycleArr += '每月';
          if (b) cycleArr += `${b}日${newArr.length == (n + 1) ? '' : '、'}`;
        });
      }
      return cycleArr;
    },
    // 滚动加载数据
    scrollData(e) {
      const ele = e.srcElement ? e.srcElement : e.target;
      if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100 && this.loading == false) {
        // 监听滚动到div底部
        this.loading = true;
        this.phoneSearch();
      }
    },
    // 修改cardListShow的值
    editCardListShow(val) {
      this.cardListShow = val;
    },
    // 点击弹出详情
    openListy(packageId, clientVipCardId) {
      const data = {
        mainId: window.sessionStorage.mainId,
        phone: this.phoneSearchVal,
        packageId,
        clientVipCardId,
      };
      this.cardListShow = true;
      this.detailsLoading = true;
      getDeductDetails(data).then((res) => {
        if (res.code == 0) {
          res.data.hiddenStatus = false;
          if (res.data.type !== 1) {
            if (res.data.clientVipCardItemInfoList) {
              res.data.clientVipCardItemInfoList.forEach((item2) => {
                item2.isDisabled = 0;
                item2.cardId = res.data.id;
                item2.percentage4ServeList = [];
                item2.count = item2.residueCount >= 1 ? 1 : 0;
                // item2.expenseCount = item2.residueCount == 0 ? 0 : 1;
                item2.chooseList = [
                  {
                    dictItemName: item2.dictItemName,
                    isDisabled: item2.isDisabled,
                    percentage4ServeList: item2.percentage4ServeList,
                    isPercentage: item2.isPercentage,
                    residueCount: item2.residueCount,
                    itemId: item2.itemId,
                    status: item2.status
                  }
                ];
              });
            }
            if (res.data.clientPackageProductList) {
              res.data.clientPackageProductList.forEach((item3) => {
                item3.isDisabled = 0;
                item3.percentage4ProductList = [];
                item3.count = item3.residueCount >= 1 ? 1 : 0;
                item3.productCount = item3.residueCount == 0 ? 0 : 1;
              });
            }
          }
          this.detailsData = res.data;
        } else {
          console.log(res.data);
        }
        this.detailsLoading = false;
      });
    },
    // 套餐搜索
    changeMeal(type) {
      this.Cmloading = true;
      this.limitType = type;
      this.pageNum = 1;
      this.phoneSearch();
    },
    // 修改用户姓名
    editUsername(val) {
      this.editStatus = val;
      if (val == 1) {
        window.sessionStorage.rechargeName = this.MemberInfo.nickName || '';
      }
    },
    // 调用公共组件--赋值
    memberUrl(list) {
      this.form = list;
    },
    // 注册会员
    registerMember() {
      this.form.phone = this.phoneSearchVal;
      this.form.memberDialog = true;
    },
    // 查询顾客
    phoneSearch() {
      this.loading = true;
      this.Lib.keyboardBlur();
      const vm = this;
      const status = this.Lib.CheckPhone(vm.phoneSearchVal);
      if (status == false && vm.phoneSearchVal) {
        vm.$message('暂无搜索结果');
        return;
      }
      vm.Lib.keyboardBlur();
      if (vm.phoneSearchVal) {
        vm.checkMember();
      } else this.MemberInfo = {};
      vm.searchBeforePhone = vm.phoneSearchVal;
      const data = {
        mainId: window.sessionStorage.mainId,
        pageNum: vm.pageNum,
        pageSize: vm.pageSize,
        type: 0,
        phone: vm.phoneSearchVal,
        limitType: vm.limitType == 0 ? '' : vm.limitType
      };
      if (vm.phoneSearchVal) {
        window.sessionStorage.rechargePhone = vm.phoneSearchVal;
      } else {
        window.sessionStorage.rechargePhone = '';
        window.sessionStorage.rechargeName = '';
      }
      vm.phoneSearchStatus = true;
      getBeautyPackageList(data).then((res) => {
        if (res.code == 0 && res.data) {
          vm.rowCount = res.data.total;
          this.Cmloading = false;
        }
        if (vm.pageNum === 1) {
          vm.cardList = res.data ? res.data.records : [];
          vm.pageNum++;
          vm.phoneSearch();
        } else if ((res.data.pages >= res.data.current) && res.data.current != 1) {
          res.data.records.forEach((a) => {
            vm.cardList.push(a);
          });
          vm.loading = false;
          vm.pageNum++;
        }
      });
    },
    newCheckMember(val) {
      this.checkMember(val.value);
    },
    // 查询是否是会员
    checkMember(val) {
      const vm = this;
      if (val) {
        this.phoneSearchVal = val;
        vm.starStatus = 2;
      }
      vm.Lib.keyboardBlur();
      const data = {
        keyWord: vm.phoneSearchVal
      };
      getMemberCardMsg(data).then((res) => {
        if (res.code == 0) {
          if (this.rechargeStatus == 1) {
            if (!res.data.nickName) res.data.nickName = window.sessionStorage.rechargeName;
          }
          window.sessionStorage.rechargeName = '';
          this.rechargeStatus = 2;
          vm.MemberInfo = res.data ? res.data : {};
        } else {
          // console.log(res);
        }
      });
    },
    // 会员套餐购买/续费
    recharge(obj) {
      if ((obj.limitPurchase * 1 > 0) && (obj.alreadyPurchase >= obj.limitPurchase)) {
        this.$message({ type: 'warning', message: (`${obj.vipCardName}限购${obj.limitPurchase}次，该客户已购买过${obj.alreadyPurchase}次，已达上限`) });
        return;
      }
      window.sessionStorage.rechargeId = obj.id;
      this.$router.push({
        name: 'stage-recharge'
      });
    },
    // 输入建议
    querySearchAsync(queryString, cb) {
      // 获取电话输入建议总列表
      // queryString 输入框的值
      // cb 回调函数 返回查询后过滤好的列表
      const results = queryString ? this.getCustomerList(queryString) : '';
      queryString ? (queryString.length == 11 ? '' : cb(results)) : '';
    },
    // 顾客列表
    getCustomerList(val) {
      const data = {
        mainId: window.sessionStorage.mainId,
        sex: '',
        memberType: 1,
        grade: '',
        rate: '',
        birthdayStart: '',
        birthdayEnd: '',
        source: '',
        pageNum: 1,
        pageSize: 9999,
        phone: val
      };
      const phones = [];
      getCustomerMsgList(data).then((res) => {
        if (res.code == 0) {
          for (const i in res.data.records) {
            phones.push({
              value: res.data.records[i].phone,
              cardNo: res.data.records[i].cardNo,
              customerName: res.data.records[i].customerName
            });
          }
        }
      });
      return phones;
    },
    // 查询顾客列表
    onCheckPhoneBook() {
      this.innerVisible = true;
    },
  }
};
</script>

<style scoped>
.N_ti {
  color: rgb(210, 210, 210);
  flex: 1;
  position: absolute;
  margin-top: 4px;
}
.N_MD {
  width: 500px;
}
.calc_T {
  height: calc(100vh - 270px) !important;
}
.calc_ul {
  overflow-x: hidden;
  overflow-y: visible;
  height: calc(100vh - 270px) !important;
}
::-webkit-scrollbar {
  width: 6px;
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  background-color: #999;
}
</style>
<style scoped lang="less">
.infoTop {
  display: flex;
  padding: 0 0 20px 0;
  .itLeft {
    width: 70px;
    height: 70px;
    float: left;
    margin-right: 20px;
    .liOne_img {
      width: 100%;
      height: 100%;
      box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.05);
    }
  }
  .itRight {
    flex: 1;
    p {
      color: #999;
      font-size: 14px;
      height: 35px;
      line-height: 35px;
      samp {
        color: #ccc;
        cursor: pointer;
      }
      span {
        padding-left: 20px;
        color: #09d8fd;
      }
      label {
        color: #09d8fd;
      }
    }
  }
}
.infoMiddle {
  padding: 20px;
  background-color: #f5f7fa;
  display: flex;
  margin-bottom: 20px;
  .mLeft {
    margin: 13px 20px 0 0;
  }
  .mRight {
    flex: 1;
    .mrTop {
      height: 30px;
      line-height: 30px;
      p {
        float: left;
        width: 33%;
      }
    }
    .mrBottom {
      display: flex;
      line-height: 30px;
      .mrbLeft {
        min-width: 70px;
      }
      .mrbRight {
        flex: 1;
      }
    }
  }
}
.beauty_content {
  width: 100%;
  ul {
    padding: 5px 0 0 5px;
    li {
      width: 375px;
      height: 110px;
      padding: 30px 20px 20px 20px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.08);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      display: flex;
      margin: 0 20px 20px 0;
      float: left;
      position: relative;
      .liTop {
        min-width: 129px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 0px 4px 0px 4px;
        position: absolute;
        margin-top: -30px;
        right: 0;
        color: #fff;
        font-size: 14px;
      }
      .liCone {
        background-color: #409EFF;
      }
      .liCtwo {
        background-color: #F56C6C;
      }
      .liCthree {
        background-color: #909399;
      }
      .liLeft {
        flex: 1;
        width: 80px;
        padding-right: 10px;
        .img {
          width: 80px;
          height: 80px;
          .liOne_img {
            width: 100%;
            height: 100%;
            box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.05);
          }
        }
      }
      .liRight {
        width: 293px;
        h1 {
          font-size: 16px;
          color: #333;
          height: 18px;
          line-height: 18px;
        }
        h2 {
          font-size: 12px;
          color: #999;
          height: 16px;
          line-height: 16px;
          label {
            font-size: 14px;
          }
          span {
            float: right;
            color: #333;
            font-size: 14px;
          }
          del {
            float: right;
          }
        }
        h3 {
          height: 49px;
          line-height: 43px;
          samp {
            float: right;
            font-size: 14px;
            color: #09d8fd;
            cursor: pointer;
            i {
              font-size: 18px;
              position: relative;
              top: 2px;
            }
          }
        }
        h4 {
          font-size: 16px;
          color: #333;
          height: 20px;
          line-height: 20px;
          del {
            font-size: 12px;
            color: #999;
            float: right;
          }
        }
        h5 {
          font-size: 12px;
          color: #999;
          padding-top: 40px;
          height: 19px;
          line-height: 19px;
          label {
            font-size: 14px;
          }
          span {
            float: right;
            color: #333;
            font-size: 14px;
          }
          del {
            float: right;
          }
        }
      }
    }
  }
}

.liOne {
  overflow: hidden;
  position: relative;
  height: 270px;
  .tipCss {
    position: absolute;
    margin: -280px 0 0 213px;
    width: 76px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 24px;
    color: #fff;
    border-radius: 0px 10px 0px 0px;
    transform: scale(0.5);
  }
  .tip1 {
    background-color: #FF4040;
  }
  .tip2 {
    background-color: #F7B900;
  }
  .tip3 {
    background-color: #4086FF;
  }
  .tip3 {
    background-color: #4086FF;
  }
  .tip4 {
    background-color: #FF6740;
  }
  .liOne_Ti {
    position: absolute;
    left: -2px;
    top: -2px;
  }
  .liOne_img {
    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.05);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
}
.beautyTop {
  width: 100%;
  margin-bottom: 15px;
  .tipInfo {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    padding: 0 15px;
    color: #E6A23C;
    background: #FDF6EC;
    border-radius: 4px;
    border: 1px solid #FAECD8;
    i {
      padding-right: 5px;
    }
  }
}
.screen {
  color: #999;
  font-size: 20px;
  cursor: pointer;
  float: right;
  margin-top: 10px;
  position: relative;
  z-index: 1;
}
.beauty_select_text {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
}
/*公共样式*/
.brauty_font_overflow {
  display: flex;
}
.brauty_font_overflow label {
  max-width: 500px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.newFootCss {
  padding: 15px 0 20px 0;
  .newFootCode {
    float: right;
    margin-top: 10px;
    .newPrice {
      color: #666;
      font-size: 14px;
      padding: 10px 0 10px 35px;
      small {
        color: #ff2233;
        font-size: 16px;
      }
    }
  }
  .newFootBtn {
    float: right;
    display: block;
    width: 100%;
    text-align: right;
    padding-top: 7px;
  }
}
.merber_info_none {
  height: 80px;
  border: 1px solid #d8dce5;
  padding: 26px 0 14px 0;
  margin-top: 15px;
  i {
    display: block;
    text-align: center;
    font-size: 30px;
    color: #cecece;
  }
  p {
    font-size: 14px;
    color: #999;
    text-align: center;
    height: 50px;
    line-height: 50px;
    span {
      cursor: pointer;
    }
  }
}
.srcoll {
  width: 100%;
  display: -webkit-box;
  height: 60px;
  padding: 10px 0 15px 0;
  overflow-x: visible;
  overflow-y: hidden;
  .i_one {
    float: left;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 50%;
    background-color: #fff;
    margin: 0 20px 0 30px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    i {
      color: #999;
      font-size: 28px;
    }
  }
  .li {
    float: left;
    padding: 8px 30px 8px 0;
    position: relative;
    h5 {
      font-size: 14px;
      color: #333;
      height: 16px;
      line-height: 16px;
    }
    p {
      font-size: 14px;
      color: #333;
      height: 28px;
      line-height: 28px;
      b {
        float: left;
        font-weight: 500;
      }
      .liBtn {
        float: left;
        width: 180px;
        margin-right: 10px;
      }
      .i_three {
        font-size: 16px;
        color: #fd5c8c;
        padding-left: 5px;
        cursor: pointer;
      }
      span {
        float: left;
        font-size: 12px;
        background-color: #ffe9ee;
        color: #fd5c8c;
        height: 19px;
        line-height: 19px;
        border-radius: 8px;
        margin-left: 10px;
        padding: 0 5px 0 23px;
        position: relative;
        top: 4px;
        i {
          position: relative;
          display: block;
          float: left;
          font-size: 12px;
          margin: -2px 0 0 -25px;
          background-color: #ffe9ee;
          text-align: center;
          width: 23px;
          height: 23px;
          line-height: 23px;
          border-radius: 50%;
        }
      }
      label {
        float: right;
        font-size: 12px;
        background-color: #000;
        color: #ffc500;
        height: 19px;
        line-height: 19px;
        border-radius: 8px;
        margin-left: 10px;
        padding: 0 10px;
        position: relative;
        top: 4px;
      }
    }
  }
}
.starPhoneClass {
  position: relative;
  font-size: 18px;
  margin-top: 0;
  top: -31px;
  left: 41px;
  background-color: #fff;
  width: 33px;
  user-select: none;
}
// 6.1
.dueTiem{
  width: 714px;
  .button{
    margin:0 5px;
    font-size: 14px;
  }
}
.popoverBox{
  padding:20px 10px 0 10px;
  overflow: auto;
  h5 {
    font-size: 14px;
    color:#666;
    span {
      float: left;
      width: 72px;
      text-align: right;
    }
  }
  p{
    font-size: 14px;
    color:#606266FF;
    text-align: center;
  }
  .title{
    font-size: 14px;
    color: #303133;
    text-align: left;
  }
  .text{
    margin-bottom:5px;
    font-size: 13px;
    text-align: left;
    display: flex;
    span {
      flex: 1;
    }
    label {
      width: 100px;
      text-align: right;
      samp {
        padding: 0 3px;
      }
    }
  }
}
.package-buttonBox{
  float: right;
  height: 40px;
}
</style>

<style>
.srcoll::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.srcoll::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.srcoll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.srcoll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.N_poptext {
    max-width: 700px;
    padding: 5px !important;
}
.blockThree .is-loading {
  display: inline-block !important;
}
.checkBoxList span {
  font-size: 14px;
}
.checkBoxList .el-checkbox .el-checkbox__label {
  width: 56px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  top: 4px;
}
.el-autocomplete-suggestion li {
  padding: 0 !important;
}
.packageList li .liFour {
  width: calc(100% - 840px);
}
.el-autocomplete-suggestion li {
  padding: 0 !important;
}
.allListClass {
  width: 100%;
}
.allListClass h1 {
  height: 35px;
  background-color: #f5f7fa;
  color: #999;
  font-size: 14px;
  padding: 0 20px;
}
.allListClass p {
  height: 35px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  padding: 0 20px;
}
.allListClass p span {
  float: left;
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.allListClass p samp {
  float: right;
  width: 100px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
